<template>
    <div class="challenge-recent-challenges">
        <div class="challenge-recent-challenges__header">
            <span class="challenge-recent-challenges__heading">Son Karşılaşmalar</span>
            <router-link to="/challenge/list" class="challenge-recent-challenges__link-see-all">TÜMÜNÜ GÖR</router-link>
        </div>
        <div
            v-if="showPreloader"
            class="challenge-recent-challenges__wr-preloader">
            <img
                class="challenge-recent-challenges__preloader"
                src="@/assets/design-assets/gif-preloader-dots-333-bgmain.min.gif">
        </div>

        <p
            v-if="showEmptyState"
            class="challenge-recent-challenges__error-not-found">Karşılaşma kaydı bulunamadı.</p>
        <div class="swiper">
            <div class="swiper-wrapper">
                <div
                    class="swiper-slide"
                    v-for="challengeItem in recentChallenges" :key="challengeItem.id">
                    <CardChallengeListItemCompleted
                        :challengeItem="challengeItem" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import CardChallengeListItemCompleted from '@/components/CardChallengeListItemCompleted.vue';
    import Swiper, {Autoplay} from 'swiper';
    import 'swiper/css';

    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        data(){
            return {
                showPreloader: true,
                swiper: null,
            };
        },

        components: {
            CardChallengeListItemCompleted,
        },

        computed: {
            showEmptyState(){
                if(this.showPreloader){
                    return false;
                }
                else if(this.recentChallenges.length === 0){
                    return true;
                }
            },
            
            recentChallenges(){
                return this.$store.state.response.challenge.recentChallenges;
            }
        },

        mounted(){
            if(this.$store.state.envDev){

            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.challengeRecent, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(recentChallenges => {
                    this.$store.commit('setChallengeRecentChallenges', recentChallenges);
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.swiper = new Swiper('.swiper', {
                            modules: [Autoplay],
                            autoplay: {
                                delay: 2500,
                                disableOnInteraction: false,
                            },
                            width: 278, 
                            longSwipes: false,
                            spaceBetween: 8,
                        });
                    });
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_RECENT_MODEL/RECENT::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeRecent.${err.code}`),
                            didClose: () => {
                                this.$router.push('/login');
                            }
                        });
                        return true;
                    }
                    this.$foneturkError({
                        text: `error.default`
                    });
                });
            }
        },

        beforeUnmount(){
            this.$store.commit('setChallengeRecentChallenges', []);
        }
    };
</script>

<style scoped src="@/css/components/challenge-recent-challenges.css"></style>